import { createClient } from '@supabase/supabase-js';

// We now rely on Vite to define process.env variables via 'define' in vite.config.ts
// This allows direct access to process.env.KEY which gets replaced with the string value at build time.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only create the client if the keys are present.
// This prevents errors if the user hasn't configured Supabase yet.
export const supabase = (SUPABASE_URL && SUPABASE_ANON_KEY)
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : null;